/**
 * Dialog 组件的 emit 事件声明
 */
export const emits = [
  /**
   * actions 中的按钮被点击时触发
   * @param index 按钮在 actions 数组中的下标
   */
  'click',

  /**
   * visible 状态更新时触发，用于 v-model
   * @param visible 当前的 visible 状态
   */
  'update:visible',
];

